<div
  class="org"
  [class.es-completa]="pantallaCompleta"
  [class.es-exportando]="exportando"
>
  <!-- ==================== BARRA ==================== -->
  <header class="org__barra">
    <div class="org__cuenta">
      <b>{{ totalNodos }}</b> puestos
      <span class="org__sep" *ngIf="vacantes">·</span>
      <span class="org__vac" *ngIf="vacantes">{{ vacantes }} vacantes</span>

      <!-- Sólo aparece si hay desacuerdo. En cero no dice nada útil y
           ocuparía espacio permanentemente. -->
      <span
        class="org__aviso"
        *ngIf="desalineados"
        role="button"
        (click)="explicaDesalineado()"
        (keydown.enter)="explicaDesalineado()"
        matTooltip="Su autorizador de vacaciones no es su jefe en el diagrama. Alguien lo cambió por fuera."
      >
        <span class="material-icons">error_outline</span>
        {{ desalineados }} con autorizador distinto
      </span>
    </div>

    <div class="org__herr">
      <!-- Buscar entre 63 cajas a ojo no es buscar. Lo hallado se
           resalta, el resto se atenúa, y Enter lo centra. -->
      <label class="org__buscar">
        <span class="material-icons">search</span>
        <input
          type="text"
          [(ngModel)]="busqueda"
          name="busqueda"
          placeholder="Buscar persona o puesto…"
          (keyup.enter)="centraHallado()"
        />
        <span class="org__buscar-n" *ngIf="busqueda">{{ idsHallados.size }}</span>
        <button
          type="button"
          class="org__buscar-x"
          *ngIf="busqueda"
          (click)="busqueda = ''"
          aria-label="Limpiar"
        >
          <span class="material-icons">close</span>
        </button>
      </label>

      <button type="button" class="org__completa" (click)="exportarPdf()">
        <span class="material-icons">picture_as_pdf</span>
        FOR-016
      </button>

      <button type="button" class="org__completa" (click)="abreHistorial()">
        <span class="material-icons">history</span>
        Historial
      </button>

      <button
        type="button"
        class="org__completa"
        (click)="alternaPantalla()"
        [matTooltip]="pantallaCompleta ? 'Salir (Esc)' : 'Ver a pantalla completa'"
      >
        <span class="material-icons">
          {{ pantallaCompleta ? "fullscreen_exit" : "fullscreen" }}
        </span>
        {{ pantallaCompleta ? "Salir" : "Pantalla completa" }}
      </button>

      <div class="org__zoom">
        <button type="button" (click)="acerca(-0.15)" matTooltip="Alejar" aria-label="Alejar">
          <span class="material-icons">remove</span>
        </button>
        <span class="org__zoom-n">{{ (zoom * 100).toFixed(0) }}%</span>
        <button type="button" (click)="acerca(0.15)" matTooltip="Acercar" aria-label="Acercar">
          <span class="material-icons">add</span>
        </button>
        <button type="button" (click)="encuadra()" matTooltip="Volver al centro" aria-label="Volver al centro">
          <span class="material-icons">center_focus_strong</span>
        </button>
      </div>
    </div>
  </header>

  <p class="org__pista org__pista--mouse" *ngIf="puedeEditar && !cargando && raiz && !moviendoToque">
    Arrastra un puesto sobre otro para recolgarlo. Arrastra el fondo para
    moverte.
  </p>
  <!-- En táctil no hay arrastre de puestos: se toca el puesto y luego al
       jefe. La pista cambia con el dispositivo, vía CSS. -->
  <p class="org__pista org__pista--toque" *ngIf="puedeEditar && !cargando && raiz && !moviendoToque">
    Toca <span class="material-icons">open_with</span> en un puesto y luego
    a su nuevo jefe. Arrastra el fondo para moverte; pellizca para acercar.
  </p>
  <p class="org__pista org__pista--moviendo" *ngIf="moviendoToque">
    <span class="material-icons">open_with</span>
    Ahora toca al nuevo jefe de
    <b>{{ moviendoToque.nombre || moviendoToque.nombreLibre || moviendoToque.puesto }}</b>
    <button type="button" (click)="cancelaMoverToque()">Cancelar</button>
  </p>

  <!-- ==================== EL DIAGRAMA ==================== -->
  <div
    class="org__lienzo"
    (wheel)="rueda($event)"
    (pointerdown)="tomaLienzo($event)"
    (pointermove)="mueveLienzo($event)"
    (pointerup)="sueltaLienzo($event)"
    (pointercancel)="sueltaLienzo($event)"
    (pointerleave)="sueltaLienzo()"
  >
    <div
      #mundo
      class="org__mundo"
      *ngIf="!cargando && raiz"
      [style.transform]="
        'translate(' + desplazoX + 'px,' + desplazoY + 'px) scale(' + zoom + ')'
      "
    >
      <ng-container
        *ngTemplateOutlet="rama; context: { $implicit: raiz }"
      ></ng-container>
    </div>

    <div class="org__cargando" *ngIf="cargando">
      <span class="material-icons">hourglass_top</span>
      Cargando el organigrama…
    </div>

    <div class="org__vacio" *ngIf="!cargando && !raiz && !error">
      <span class="material-icons">account_tree</span>
      <p>El organigrama todavía no tiene puestos.</p>
    </div>

    <div class="org__error" *ngIf="error">
      <span class="material-icons">error_outline</span>
      {{ error }}
    </div>
  </div>
</div>

<!-- ==================== LA RAMA, RECURSIVA ====================
     Una plantilla que se llama a sí misma: el árbol no tiene una
     profundidad fija y escribir un nivel por cada uno la ataría a la
     forma que tiene hoy. -->
<ng-template #rama let-n>
  <!-- Cada rama fija el color de su área en variables: los conectores
       hacia SU equipo se pintan con él, y cambian solos al entrar en
       otra área. -->
  <div
    class="org-rama"
    [style.--rama]="colorArea(n)"
    [style.--rama-linea]="tinte(colorArea(n), 0.45)"
  >
    <div
      class="org-nodo"
      [class.es-arrastrando]="arrastrando === n.idNodo"
      [class.es-destino]="encima === n.idNodo"
      [class.es-vacante]="!n.idUsuario && !n.nombreLibre"
      [class.es-hallado]="hallado(n)"
      [class.es-tenue]="busqueda && !hallado(n)"
      [style.borderColor]="tinte(colorArea(n), 0.4)"
      [style.background]="tinte(colorArea(n), 0.045)"
      [attr.draggable]="puedeEditar && n.idPadre != null ? true : null"
      (dragstart)="empiezaArrastre(n, $event)"
      (dragover)="sobre(n, $event)"
      (dragleave)="sale()"
      (drop)="suelta(n, $event)"
      (dragend)="terminaArrastre()"
      (click)="tocaNodo(n, $event)"
      (keydown.enter)="$event.target === $event.currentTarget ? tocaNodo(n, $event) : null"
    >
      <div class="org-nodo__cab">
        <span
          class="org-nodo__ini"
          [style.background]="colorArea(n)"
          [class.es-vacante]="!n.idUsuario && !n.nombreLibre"
        >
          {{ iniciales(n) }}
        </span>

        <div class="org-nodo__txt">
          <!-- El puesto arriba, como en el FOR-016: el cargo dibuja la
               estructura, la persona lo ocupa. -->
          <span class="org-nodo__puesto" [matTooltip]="n.puesto || ''">
            {{ n.puesto }}
          </span>
          <span class="org-nodo__nombre">
            {{ n.nombre || n.nombreLibre || "Vacante" }}
          </span>
        </div>

        <!-- El aviso de desacuerdo va en el nodo, no sólo en el
             contador de arriba: así se ve DE QUIÉN se trata. -->
        <span
          class="org-nodo__ojo"
          *ngIf="desalineado(n)"
          (click)="explicaDesalineado(n); $event.stopPropagation()"
          (keydown.enter)="explicaDesalineado(n); $event.stopPropagation()"
          matTooltip="Sus vacaciones las autoriza alguien distinto de su jefe aquí"
        >
          <span class="material-icons">error_outline</span>
        </span>
      </div>

      <span class="org-nodo__area" *ngIf="n.area" [style.color]="colorArea(n)">
        {{ n.area }}
      </span>

      <div class="org-nodo__acc" *ngIf="puedeEditar">
        <!-- Sólo en táctil (CSS): sustituye al arrastre. -->
        <button
          type="button"
          class="es-toque"
          *ngIf="n.idPadre != null"
          (click)="empiezaMoverToque(n, $event)"
          aria-label="Mover a otro jefe"
        >
          <span class="material-icons">open_with</span>
        </button>
        <button type="button" (click)="nuevo(n)" matTooltip="Agregar debajo" aria-label="Agregar debajo">
          <span class="material-icons">add</span>
        </button>
        <button type="button" (click)="editar(n)" matTooltip="Editar" aria-label="Editar">
          <span class="material-icons">edit</span>
        </button>
        <button
          type="button"
          class="es-no"
          *ngIf="n.idPadre != null"
          (click)="eliminar(n)"
          matTooltip="Eliminar"
          aria-label="Eliminar"
        >
          <span class="material-icons">delete_outline</span>
        </button>
      </div>
    </div>

    <!-- El puesto asesor (la ODP) no va en la fila de líderes: en el
         FOR-016 cuelga del tronco, a un lado, entre la dirección y su
         fila. Quién es asesor lo dice ASESORES en el .ts, por nombre. -->
    <div
      class="org-asesor"
      [class.es-costado]="asesorAlCostado(n)"
      *ngIf="asesoresDe(n).length"
    >
      <ng-container *ngFor="let a of asesoresDe(n); trackBy: trackNodo">
        <ng-container
          *ngTemplateOutlet="rama; context: { $implicit: a }"
        ></ng-container>
      </ng-container>
    </div>

    <!-- Los equipos de puros subordinados se apilan en lista, como en
         el PDF: es lo que evita que una rama de catorce personas mida
         tres pantallas de ancho. -->
    <!-- Un equipo de puros subordinados se acomoda en RENGLONES por
         puesto, como la banda del FOR-016: Sr arriba, la fila de Med,
         la fila de Jr. Los puestos únicos quedan de una caja por
         renglón, así que los equipos chicos siguen bajando igual. -->
    <div
      class="org-hijos"
      *ngIf="hijosDeFila(n).length"
      [class.es-lista]="esLista(n)"
      [class.es-banda-fila]="esLista(n) && bandaDeFila(n)"
      [class.es-fila-con-banda]="filaConBanda(n)"
      [style.--lideres]="filaConBanda(n) ? hijosDeFila(n).length : null"
    >
      <ng-container *ngIf="esLista(n); else columnas">
        <div class="org-hijo" *ngFor="let g of gruposDe(n); trackBy: trackGrupo">
          <div class="org-fila" [style.--cols]="g.items.length">
            <ng-container *ngFor="let h of g.items; trackBy: trackNodo">
              <ng-container
                *ngTemplateOutlet="rama; context: { $implicit: h }"
              ></ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ng-template #columnas>
        <div
          class="org-hijo"
          *ngFor="let h of hijosDeFila(n); trackBy: trackNodo"
          [class.es-col-equipo]="esLista(h) && bandaDeFila(h)"
        >
          <ng-container
            *ngTemplateOutlet="rama; context: { $implicit: h }"
          ></ng-container>
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>

<!-- ==================== MODAL ==================== -->
<div class="org-modal" *ngIf="editando">
  <div class="org-modal__caja">
    <div class="org-modal__cab">
      <h3>{{ editando.idNodo ? "Editar puesto" : "Nuevo puesto" }}</h3>
      <button type="button" class="org-modal__x" (click)="cancelar()">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="org-modal__cuerpo">
      <!-- De quién cuelga, dicho de frente: sin esto, agregar tres
           puestos seguidos acaba con alguno colgado del lugar
           equivocado sin que nadie lo note. -->
      <p class="org-modal__padre" *ngIf="!editando.idNodo && nombrePadreNuevo">
        <span class="material-icons">subdirectory_arrow_right</span>
        Colgará de <b>{{ nombrePadreNuevo }}</b>
      </p>

      <label class="org-campo org-campo--sugiere">
        <span>Puesto</span>
        <!-- Sugerencias del catálogo real (adm_puesto) en panel propio:
             "Líder" capturado como "Lider" rompe el agrupamiento sin
             aviso, y el datalist nativo no se puede estilar. -->
        <input
          type="text"
          [(ngModel)]="editando.puesto"
          name="puesto"
          maxlength="120"
          autocomplete="off"
          placeholder="Director, Líder, Desarrollador…"
          (focus)="sugerenciasAbiertas = true"
          (blur)="sugerenciasAbiertas = false"
        />
        <div
          class="org-sugiere"
          *ngIf="sugerenciasAbiertas && puestosSugeridos.length"
        >
          <button
            type="button"
            class="org-sugiere__op"
            *ngFor="let p of puestosSugeridos"
            (pointerdown)="eligePuesto(p, $event)"
          >
            {{ p }}
          </button>
        </div>
      </label>

      <label class="org-campo">
        <span>Quién lo ocupa</span>
        <!-- Buscador arriba del select: 44 personas sin filtro es
             recorrer la lista entera cada vez. -->
        <input
          type="text"
          class="org-campo__buscar"
          [(ngModel)]="filtroPersona"
          name="filtroPersona"
          placeholder="Escribe para filtrar por nombre, usuario o puesto…"
        />
        <select [(ngModel)]="editando.idUsuario" name="idUsuario">
          <option [ngValue]="null">Vacante o persona externa</option>
          <option *ngFor="let p of personasFiltradas" [ngValue]="p.idUsuario">
            {{ p.nombre }} · {{ p.puesto || p.usuario }}
          </option>
        </select>
      </label>

      <!-- Sólo cuando no hay usuario de COS: un despacho externo, o
           alguien en proceso de contratación. -->
      <label class="org-campo" *ngIf="!editando.idUsuario">
        <span>Nombre, si es alguien de fuera</span>
        <input
          type="text"
          [(ngModel)]="editando.nombreLibre"
          name="nombreLibre"
          maxlength="140"
          placeholder="Despacho externo, contabilidad…"
        />
      </label>

      <!-- El orden entre hermanos se asigna solo al agregar y se
           conserva al editar: era un numero que nadie sabia que poner. -->
      <label class="org-campo">
        <span>Área</span>
        <select [(ngModel)]="editando.idArea" name="idArea">
          <option [ngValue]="null">Sin área</option>
          <option *ngFor="let a of areas" [ngValue]="a.idArea">{{ a.area }}</option>
        </select>
      </label>

      <p class="org-campo__nota">
        Un puesto puede estar vacante: el organigrama lo muestra igual, con
        el círculo en gris. De quién cuelga no se cambia aquí — eso se hace
        arrastrándolo en el diagrama, porque puede afectar sus vacaciones.
      </p>
    </div>

    <div class="org-modal__pie">
      <button type="button" class="org__btn org__btn--fantasma" (click)="cancelar()">
        Cancelar
      </button>
      <button type="button" class="org__btn" [disabled]="guardando" (click)="guardar()">
        {{ guardando ? "Guardando…" : "Guardar" }}
      </button>
    </div>
  </div>
</div>

<!-- ==================== MODAL: HISTORIAL ==================== -->
<div class="org-modal" *ngIf="historialAbierto" (click)="historialAbierto = false" (keydown.enter)="$event.target === $event.currentTarget ? (historialAbierto = false) : null">
  <div class="org-modal__caja org-modal__caja--hist" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null">
    <div class="org-modal__cab">
      <h3>Historial de movimientos</h3>
      <button type="button" class="org-modal__x" (click)="historialAbierto = false">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="org-modal__cuerpo org-modal__cuerpo--hist">
      <div class="org-hist" *ngIf="!cargandoHistorial && historial.length">
        <div class="org-hist__it" *ngFor="let h of historial; trackBy: trackHist">
          <span
            class="org-hist__accion"
            [style.background]="tinte(colorAccion(h.accion), 0.12)"
            [style.color]="colorAccion(h.accion)"
          >
            {{ h.accion }}
          </span>
          <div class="org-hist__txt">
            <p>{{ h.detalle }}</p>
            <span>{{ h.usuario }} · {{ h.fecha }}</span>
          </div>
        </div>
      </div>

      <p class="org-hist__vacio" *ngIf="!cargandoHistorial && !historial.length">
        Todavía no hay movimientos registrados. El historial arranca a
        partir de ahora: cada alta, edición, movimiento o baja queda
        escrita con quién y cuándo.
      </p>

      <p class="org-hist__vacio" *ngIf="cargandoHistorial">Consultando…</p>
    </div>
  </div>
</div>

